export default __webpack_public_path__ + "static/media/Akash Chouhan - Akash Chouhan.80c12ea5.jfif";